/**
 * @file コンポーネント：タブ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledTab,
    StyledTabContentlist,
    StyledTabContentlistItem,
    StyledTabTriggerAnchor,
    StyledTabTriggerAnchorIcon,
    StyledTabTriggerAnchorText,
    StyledTabTriggerlist,
    StyledTabTriggerlistItem,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <>
            {props.list.length > 0 && (
                <StyledTab data-name="tab">
                    <StyledTabTriggerlist
                        data-name="tab-triggerlist"
                        data-on-color={props.onColor}
                    >
                        {props.list.map((tab, index) => (
                            <React.Fragment key={"trigger-" + index}>
                                {tab.hasContent !== false && (
                                    <StyledTabTriggerlistItem
                                        data-name="tab-triggerlist-item"
                                        data-trigger-size={props.triggerSize}
                                    >
                                        <StyledTabTriggerAnchor
                                            className={[
                                                props.selectedTab ===
                                                    tab.name && "is-selected",
                                                tab.disabled && "is-disabled",
                                            ]}
                                            data-on-color={props.onColor}
                                            href="#"
                                            id={"js-tab-trigger-" + tab.name}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (!tab.disabled) {
                                                    props.setSelectedTab(
                                                        tab.name
                                                    );
                                                }
                                            }}
                                        >
                                            {tab.triggerIcon && (
                                                <StyledTabTriggerAnchorIcon>
                                                    {tab.triggerIcon}
                                                </StyledTabTriggerAnchorIcon>
                                            )}
                                            <StyledTabTriggerAnchorText>
                                                {tab.triggerText}
                                            </StyledTabTriggerAnchorText>
                                        </StyledTabTriggerAnchor>
                                    </StyledTabTriggerlistItem>
                                )}
                            </React.Fragment>
                        ))}
                    </StyledTabTriggerlist>
                    <StyledTabContentlist
                        data-name="tab-contentlist"
                        data-on-color={props.onColor}
                        ref={props.refContent}
                    >
                        {props.list.map((tab, index) => (
                            <React.Fragment key={"content-" + index}>
                                {tab.hasContent !== false && (
                                    <StyledTabContentlistItem
                                        className={
                                            props.selectedTab === tab.name &&
                                            "is-selected"
                                        }
                                        data-name="tab-contentlist-item"
                                        id={"js-tab-content-" + tab.name}
                                    >
                                        {tab.content}
                                    </StyledTabContentlistItem>
                                )}
                            </React.Fragment>
                        ))}
                    </StyledTabContentlist>
                </StyledTab>
            )}
        </>
    );
};
